import React from 'react';
import {MetricsElement} from 'react-metrics';

import { Helpers } from '../../core/src/helpers';
import ProductPrice from '../../product/components/product-price';
import Price from '../../shared/components/price';
import CheckboxCTA from './checkbox-cta';
import ProductDetailRow from '../../product/components/product-detail-row';
import PurchaseButtonContainer from '../../product/components/purchase-button-container';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';
import Link from '../../shared/components/hyperlink';

import '../css/xsell-modal.less';

const XSellProductItem = ({ added, baseProductSku, product, xsellTemplate, handleAddandRemove, priceProps, isBundleTest, productClickMetrics, ctaMetrics }) => {
    const hasProductClickMetrics = productClickMetrics && typeof productClickMetrics === 'object';
    const link = (
        <Link className="xsell-item-header" to={product.linkUrl} target='_blank' title={product.name} {...hasProductClickMetrics ? productClickMetrics : {}}> 
            <div className="xsell-header-title">
                <h3>{product.name}</h3>
            </div>
        </Link>
    );
    const imageSrc = Helpers.getCDNUrl(product.images[0].cdn, product.images[0].lrg);
    return(
        <div className={`xsell-product ${xsellTemplate}`}>
            <ImageWithPlaceholder className='xsell-image-item' src={imageSrc} alt={product.name} />
            <div className='xsell-product-body'>
                {
                    hasProductClickMetrics
                    ? <MetricsElement>{link}</MetricsElement>
                    : link
                }
                <div className="xsell-item-rating">
                    <ProductDetailRow 
                        className="xsell-item-rating" 
                        product={product}
                        displayAvgRating={true}
                        displaySkuID={false}
                    />
                </div>
                <div className='xsell-item-info'>
                    { isBundleTest ?
                        <div className='price'>
                            <div className='prd-price'><Price {...priceProps}/></div>
                        </div> :
                        <ProductPrice product={product}/>
                    }
                    {xsellTemplate === 'tabs' || xsellTemplate === 'sixup' ? 
                        <CheckboxCTA 
                            product={product}
                            handleAddandRemove={handleAddandRemove}
                            added={added}
                            baseProductSku={baseProductSku}
                            xsellTemplate={xsellTemplate}
                            ctaMetrics={ctaMetrics}
                        /> : 
                        <PurchaseButtonContainer 
                            product={product} 
                            variant={ {baseSKU: baseProductSku} } 
                            ctaMetrics={ctaMetrics}
                        />
                    }
                </div>
            </div>
        </div>
    );
}

export default XSellProductItem;